var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      key: _vm.itemData.caption + "-row",
      ref: _vm.itemData.caption,
      staticClass: "powerbar-nav-second-level-item",
      on: { click: _vm.toggleEventsPanel, keyup: _vm.toggleEventsPanel }
    },
    [
      _c("div", { staticClass: "powerbar-nav-second-level-item__col" }, [
        _c(
          "a",
          {
            key: _vm.itemData.caption + "-link",
            staticClass: "powerbar-nav-second-level-item__link",
            class: _vm.additionalClassesForItem(_vm.itemData),
            attrs: {
              href: _vm.itemData.actionUrl,
              target: _vm.itemData.window === "newWindow" ? "_blank" : ""
            },
            on: {
              click: function($event) {
                return _vm.navigateAction($event, _vm.itemData)
              }
            }
          },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.itemData.caption) + "\n        "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "powerbar-nav-second-level-item__col" }, [
        _vm.itemData.shortcut
          ? _c(
              "p",
              {
                key: _vm.itemData.caption + "-shortcut",
                staticClass: "powerbar-nav-second-level-item__shortcut"
              },
              [_vm._v(_vm._s(_vm.itemData.shortcut))]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "powerbar-nav-second-level-item__col" }, [
        _vm.itemData.events
          ? _c("span", {
              key: _vm.itemData.caption + "-indicator",
              staticClass: "powerbar-nav-second-level-item__has-third-level"
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.itemData.events
        ? [
            _c("events-panel", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showEventsPanel,
                  expression: "showEventsPanel"
                }
              ],
              key: _vm.itemData.events.caption,
              attrs: {
                items: _vm.itemData.events.items,
                caption: _vm.itemData.events.caption
              },
              on: { navigate: _vm.navigate }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }